<div *ngIf="!campaignBannerUrl.length">
	<div class="renewal-graphic">
		<img src="assets/image/renewal-graphic.png" alt="" />
	</div>
	<div class="renewal-content">
		<div fxLayout="row">
			<mat-icon> info_outline </mat-icon>
			<div>
				<b>
					{{ "renewal.oopsCarInsurance" | translate }}
				</b>
				<br />
				<br />
				<div>
					{{ "renewal.youHaveLeft" | translate }} {{ day }}
					{{ "renewal.beforeAble" | translate }}
				</div>
				<br />
				<div>
					{{ "renewal.letUsKnow" | translate }}
				</div>
			</div>
		</div>
	</div>

	<div fxLayout="row" fxLayoutGap="16px" style="margin-left: 16px; margin-bottom: 16px; margin-right: 16px">
		<div fxFlex>
			<button mat-flat-button mat-dialog-close class="white-btn">
				{{ "renewal.close" | translate }}
			</button>
		</div>
		<div fxFlex>
			<button mat-flat-button mat-dialog-close class="secondary-btn">
				{{ "renewal.remindMe" | translate }}
			</button>
		</div>
	</div>
</div>


<!-- Display when there is campaign available -->
<div class="renewal-container" *ngIf="campaignBannerUrl.length">
	<div class="renewal-banner swiper-container">
		<swiper #swiper [config]="swiperOptions">
			<ng-container *ngFor="let banner of campaignBannerUrl">
				<ng-template swiperSlide>
					<img swiperSlide [src]="banner" [alt]="banner" />
				</ng-template>
			</ng-container>
		</swiper>
	</div>
	
	<div>
		<div class="renewal-title">{{ "renewal.notTooEarlyToSave" | translate }}</div>

		<div class="renewal-content">
			<div class="top">
				<div>
					{{ "renewal.youStillHave" | translate }}
					<strong>{{ day }} </strong>
					<span [innerHTML]="'renewal.beforeCanRenew' | translate"></span>
				</div>
				<div [innerHTML]="'renewal.lockDeal' | translate"></div>
				<div>
					{{ "renewal.secureDeal" | translate }}
				</div>
			</div>

			<div class="bottom">
				<div class="note-label">
					{{ "renewal.lockDealNote" | translate }}
				</div>
				<a href="https://www.policystreet.com/tnc" target="_blank" rel="noopener noreferrer">
					{{ "renewal.tnc" | translate }}
				</a>
			</div>
		</div>
	</div>

	<div class="button-wrapper">
		<button mat-flat-button mat-dialog-close class="white-btn">
			{{ "renewal.close" | translate }}
		</button>
		<button mat-flat-button class="secondary-btn" (click)="secureDiscountDeal()">
			{{ "renewal.lockItIn" | translate }}
		</button>
	</div>
</div>
